import React from "react";

function About() {
  return (
    <div id="about" className="mt-10 max-w-7xl mx-auto px-4 sm:px-6 ">
      <h2 className="text-2xl font-bold mb-8">About.</h2>
      <p className="text-gray-900 p-2 text-base sm:text-lg lg:text-xl leading-relaxed">
        As an experienced MERN stack developer with a B.Tech in Computer
        Science, I excel at solving complex problems and building scalable
        solutions. With over 500+ solved DSA problems on LeetCode and
        certifications in C++, JavaScript, and problem-solving, I have
        demonstrated my proficiency in tackling technical challenges. My
        projects, including an Online Food Ordering System and Face Recognition
        Attendance System, showcase my ability to develop dynamic, user-centric
        applications. I am confident my problem-solving skills and hands-on
        project experience will make a meaningful impact at your organization.
      </p>
    </div>
  );
}

export default About;
